import { TFunction } from "i18next";

import { Text } from "@pentabd/ui";
import { ProfileInfoCard, StatusBadge } from "@components";
import { ProcurementType } from "@type/procurements/procurement";
import { NavigateFunction } from "react-router-dom";
import { IconEye } from "@pentabd/icons";

export const TableColumn = (
  t: TFunction<"translation", undefined>,
  navigate: NavigateFunction,
) => {
  return [
    {
      id: 1,
      key: "nameEn",
      name: t("PROCUREMENT_CREATE_TABLE.TABLE.COLUMN.PROCUREMENT_NAME"),
      render: (nameEn: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {nameEn}
        </Text>
      ),
    },
    {
      id: 2,
      key: "procurementRefNo",
      name: t("PROCUREMENT_CREATE_TABLE.TABLE.COLUMN.REF_NO"),
      render: (procurementRefNo: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {procurementRefNo}
        </Text>
      ),
    },
    {
      id: 4,
      key: "totalEstimatedCost",
      name: t("PROCUREMENT_CREATE_TABLE.TABLE.COLUMN.TOTAL_PRICE"),
      render: (totalEstimatedCost: number) => (
        <Text color="subtitle1" className="text-nowrap">
          {totalEstimatedCost}
        </Text>
      ),
    },
    {
      id: 5,
      key: "fileOnHand",
      name: t("PROCUREMENT_CREATE_TABLE.TABLE.COLUMN.REQUESTER_NAME"),
      render: (_: string, row: ProcurementType) => {
        if (row.fileOnHand) {
          return <ProfileInfoCard employee={row.fileOnHand} />;
        } else {
          return (
            <Text color="subtitle1" className="text-nowrap">
              N/A
            </Text>
          );
        }
      },
    },
    {
      id: 6,
      key: "status",
      name: "Status",
      render: (status: string) => {
        return <StatusBadge status={status} />;
      },
    },
    {
      id: 7,
      key: "id",
      name: "",
      render: (id: string | number) => {
        return (
          <div onClick={() => navigate(`${id}`)}>
            <IconEye size="20" />
          </div>
        );
      },
    },
  ];
};
